<template>

    <div>

        <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation" style="border-bottom: solid 1px #ececec">
            <div class="navbar-brand">
                <a class="navbar-item" :href="url">

                    <img src="https://images.livspace-cdn.com/plain/https://d3gq2merok8n5r.cloudfront.net/icons-1649318316-fdhoh/livspace-logo-black-1649339703-V6ZMt.png" style="width: 200px">
                </a>


            </div>

            <div id="navbarBasicExample" class="navbar-menu">
                <div class="navbar-end">
                    <div class="navbar-item">
                        <div class="buttons">
                            <a :href="url" class="button mx-2">
                                Home
                            </a>
                            <a href="javascript:void(0)" v-on:click="logout" class="button">
                                Log out
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <div class="container" v-if="userResponse.user">

            <div class="row p-2 p-md-4">
                <div class="col-12 pb-4" align="center">
                    <v-icon name="user-circle" scale="5" class=""></v-icon>
                    <h3 class="pl-0 pt-2">Welcome <span>{{userResponse.user.name}} !</span></h3>
                </div>

                <div class="col-12 card p-0" >
                    <div class="card-header h5">
                        Basic Information
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item">Email : {{userResponse.user.email}} </li>
                        <li class="list-group-item">
                            <span>Password : <span class="position-relative top-4">******</span> </span>
                            <span class="change-password px-2" v-on:click="changePassword">( Change Password )</span>
                        </li>
                    </ul>
                </div>


                <div class="col-12 card p-0 mt-4" v-for="auth in userResponse.authList" v-if="(auth.type === 'phone')">
                    <div class="card-header text-capitalize h5">
                        {{auth.type}} Information
                    </div>
                    <ul class="list-group list-group-flush"  >
                        <li class="list-group-item">Info : {{auth.username}} </li>
                        <li class="list-group-item">Status :
                            <span v-if="auth.verify">
                            <v-icon name="check-circle" scale="1.25" class="text-success"></v-icon>
                            Verified
                        </span>
                        <span v-if="!auth.verify" >
                            <v-icon name="exclamation-circle" scale="1.25" class="text-danger"></v-icon>
                            Not Verified <span  class="text-primary arrow-left" v-on:click="verifyUser(auth.username)">, Verify now</span>
                        </span>
                        </li>

                    </ul>
                </div>

                <div v-if="!phoneInAuthList"  class="col-12 card p-0 mt-4">
                    <div class="card-header text-capitalize h5">
                        Phone Information
                    </div>
                    <ul class="list-group list-group-flush"  >
                        <li class="list-group-item arrow-left" v-on:click="addPhone"><v-icon name="plus-circle" scale="1.25" class="text-success"></v-icon> Add Mobile </li>
                    </ul>
                </div>

                <div class="p-3 w-100 text-center">


                    <div class="center p20">
                        Not you?
                        <a class="is-info" href="javascript:void(0)" v-on:click="logout">Logout</a>
                    </div>

                </div>

            </div>

        </div>

    </div>



</template>

<script>

    import Services from '../../services';
    import CommonCode from '../mixins/CommonCode';
    import UserUtils from '../mixins/UserUtils';

    export default {

        mixins: [ CommonCode ,UserUtils ],

        data() {
            return {
                url : window.env.DOMAIN_URL,
                userResponse: {}
            }
        },

        methods: {
            logout() {

                Services.logout().then(response => {
                    this.clearLocalStorage();
                    this.windowRedirection(response.data.redirect_uri);
                });
            },

            changePassword() {
                this.$router.push({name: this.getSendOtpEntity()}, () => {});
            },

            verifyUser(username) {

                let parsePhone = this.parsePhonenumber(username);
                this.fetch_data.mobile = parsePhone.phone_number;
                this.fetch_data.isdcode = parsePhone.isdcode;
                let data = {};
                data['mobile'] = this.fetch_data.mobile;
                data['isdcode'] = this.fetch_data.isdcode;

                data['back'] = this.$route.name;

                this.$router.push({name: this.getVerifyMobileEntity(), params: data}, () => {});
            },

            addPhone(){
                let data = {};
                data['back'] = this.$route.name;
                this.$router.push({name: this.getAddMobileEntity(), params: data}, () => {});
            }
        },

        mounted() {
            this.windowRedirection(this.url);
        },

        computed: {

            phoneInAuthList: function () {
                let i;
                for( i=0; i < (this.userResponse.authList).length; i++){
                    if(this.userResponse.authList[i]['type'] === 'phone')
                        return true;
                }
            },
        }


    }
</script>

<style scoped>

</style>
